// extracted by mini-css-extract-plugin
export default {"dimensionSpinner":"DimensionSpinner_dimensionSpinner__lW092","spinPulse":"DimensionSpinner_spinPulse__R3f2-"};